import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const DeleteConfirmationModal = ({ isOpen, toggle, onConfirm, societyName }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Confirmar Eliminación</ModalHeader>
      <ModalBody>
        <p>
          ¿Estás seguro de que deseas eliminar el firmante{' '}
          <strong>{societyName}</strong>? Esta acción no se puede deshacer.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button color="danger" onClick={onConfirm}>
          Eliminar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmationModal;